import { PlayerComRosto, rostoDoPlayer } from '../minha-equipe-calculos';
import { PessoaEncontrada } from './ModalDeBusca';

/** `extra` de quem as buscas dos modais devolvem; só o gestor traz `id` (player_fields) e `nome_guerra`. */
export type ExtraDaBusca = PlayerComRosto['extra'] & { id?: string; nome_guerra?: string; diretoria?: string; funcao?: string };

/** Gestor como o `find/get_gestores` e o `find/get_gestor_prefixo` devolvem; `_id` é a matrícula. */
export interface GestorEncontrado extends PlayerComRosto {
  _id: string;
  name?: string;
  cod_etapa?: number;
  extra?: ExtraDaBusca;
}

/** "{diretoria} · {funcao}", sem o separador quando falta um dos dois. */
export function detalheDaPessoa(diretoria?: string, funcao?: string): string {
  return [diretoria, funcao].filter(Boolean).join(' · ');
}

export function pessoaDoGestor(gestor: GestorEncontrado): PessoaEncontrada<GestorEncontrado> {
  return {
    id: gestor._id,
    nome: gestor.name ?? gestor.extra?.nome_guerra ?? gestor._id,
    chave: gestor._id,
    detalhe: detalheDaPessoa(gestor.extra?.diretoria, gestor.extra?.funcao),
    rosto: rostoDoPlayer(gestor),
    dados: gestor,
  };
}
